import { RootState } from '@src/reducers';
import UserApi from '@src/api/UserApi';
import { Actions } from '@src/constants/Constants';
import { ILoginState, ILoginView } from '@src/reducers/LoginReducer';
import { PreloaderActions } from '@src/actions/PreloaderActions';
import { AlertActions } from '@src/actions/AlertActions';
import { __ } from '@src/utils/i18Abstract';

export namespace AppActions {
    import IS_USER_LOADING = Actions.IS_USER_LOADING;
    import IS_USER_AUTHORIZED = Actions.IS_USER_AUTHORIZED;
    import SHOW_OVERLAY = Actions.SHOW_OVERLAY;
    import CHANGE_VIEW = Actions.CHANGE_VIEW;
    import UPDATE_USER_PHONE = Actions.UPDATE_USER_PHONE;
    import SHOW_PROVIDE_PIN = Actions.SHOW_PROVIDE_PIN;

    export function init(withBigPreloader: boolean = false) {
        return async (dispatch: any, getState: () => RootState) => {
            if (withBigPreloader) {
                dispatch(PreloaderActions.isVisible(true));
            }

            dispatch({ type: IS_USER_LOADING, payload: true });
            const response = await UserApi.getStatus();

            if (withBigPreloader) {
                dispatch(PreloaderActions.isVisible(false));
            }

            dispatch({ type: IS_USER_LOADING, payload: false });
            dispatch({
                type: IS_USER_AUTHORIZED,
                payload: {
                    isAuthorized: response.isAuthorized,
                    username: response.username,
                },
            });
        };
    }

    export function showOverlay(view: string) {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch({ type: SHOW_OVERLAY, payload: view });
        };
    }

    export function updatePhone(payload: string) {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch({ type: UPDATE_USER_PHONE, payload });
        };
    }

    export function changeView(payload: ILoginView) {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch({ type: CHANGE_VIEW, payload });
        };
    }

    export function showProvidePin(isPrivate: boolean) {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch({ type: SHOW_PROVIDE_PIN, payload:
                isPrivate ? __('enterPasswordReceivedInSms') : __('enterPasswordReceivedInEmail')
            });
        };
    }

    export function changePin(
        username: string,
        resetPassword: boolean = false,
    ) {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch(PreloaderActions.isVisible(true));
            const response = resetPassword
                ? await UserApi.resetPassword(username)
                : await UserApi.changePin(username);
            dispatch(PreloaderActions.isVisible(false));

            console.log({ response });

            const loginState: ILoginState = getState().loginState;

            if (!response.successful) {
                const msg: string = loginState.view === ILoginView.register
                    ? __('alertErrorRegister')
                    : __('alertErrorForgotPassword');
                dispatch(AlertActions.show(response.message || msg));
                return;
            }
            if (!resetPassword) {
                dispatch(AppActions.updatePhone(username));
            }

            dispatch(AppActions.showProvidePin(response.isPrivate));
            dispatch(AppActions.changeView(ILoginView.login));
        };
    }

    export function logout() {
        return async (dispatch: any, getState: () => RootState) => {
            dispatch(PreloaderActions.isVisible(true));
            const response = await UserApi.logout();
            dispatch(PreloaderActions.isVisible(false));
            dispatch(AppActions.init(true));
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/AppActions.ts